<template>
  <v-navigation-drawer
    app
    clipped
    fixed
    permanent
    v-if="$vuetify.breakpoint.mdAndUp"
  >
    <OSelectSingleDialog
      ref="ledVarDialog"
      title="Selecionar Variável..."
      :items="screenVarOpts"
      labelProp="text"
    />

    <v-toolbar flat>
      <v-btn icon @click="$router.push('/setup/screen-sets')">
        <v-icon>mdi-arrow-left</v-icon>
      </v-btn>
      <v-toolbar-title>Scr.Set #{{ value.id }}</v-toolbar-title>
      <v-spacer />
      <OMenuButton :menuOpts="menuOpts" />
    </v-toolbar>

    <v-divider />

    <v-card flat>
      <v-card-text class="v-row">
        <v-sheet class="v-row appliesTo-shaped pa-4 mb-2">
          <label class="caption">Código</label>
          <v-btn icon @click="editCode">
            <v-icon>mdi-pencil</v-icon>
          </v-btn>
          {{ value.code || '—' }}
        </v-sheet>

        <v-sheet class="v-row appliesTo-shaped pa-4 mb-2">
          <label class="caption">Nome</label>
          <v-btn icon @click="editName">
            <v-icon>mdi-pencil</v-icon>
          </v-btn>
          {{ value.name || '—' }}
        </v-sheet>

        <v-sheet class="v-row appliesTo-shaped pa-4 mb-2">
          <label class="caption">Notas/Observações</label>
          <v-btn icon @click="editComments">
            <v-icon>mdi-pencil</v-icon>
          </v-btn>
          {{ cappedComments }}
        </v-sheet>

        <label class="caption">LEDs</label>

        <div class="v-row">
          <v-btn
            v-for="led in leds"
            :key="led.code"
            :color="led.color"
            @click="chooseLedVar(led)"
          >
            <span v-if="led.variable == null">&mdash;</span>
            <span v-else>{{ led.variable | translateVar }}</span>
          </v-btn>
        </div>
      </v-card-text>
    </v-card>
  </v-navigation-drawer>
</template>

<script>
import { screenVarOpts, translateVar } from './screen-opts'
import utils from 'oderon-commons/src/utils'
import OSelectSingleDialog from 'oderon-vue/cpts/OSelectSingleDialog.vue'

const ledColors = ['green', 'amber', 'blue', 'red']

export default {
  components: { OSelectSingleDialog },
  props: {
    value: { type: Object, required: true }
  },
  computed: {
    leds() {
      let result = []
      for (let i = 0; i < 4; i++) {
        let color = ledColors[i]
        let variable = this.value['led' + i]
        result.push({ code: i, color, variable })
      }
      return result
    },
    menuOpts() {
      return [
        {
          icon: 'mdi-refresh',
          text: 'Reload',
          onClick: () => this.$emit('reload')
        },
        {
          icon: 'mdi-hexadecimal',
          text: 'Ver Hex',
          onClick: () =>
            this.$emit('preview', { type: 'screen-set', obj: this.value })
        },
        {
          icon: '',
          text: 'Criar Checklist...',
          onClick: () => this.$emit('createChecklist')
        },
        {
          icon: '',
          text: 'Embarcar...',
          onClick: () => this.$emit('embed')
        }
      ]
    },
    cappedComments() {
      if (utils.isEmpty(this.value.comments)) return '—'
      if (this.value.comments.length > 100)
        return this.value.comments.substring(0, 100) + '...'
      return this.value.comments
    }
  },
  data() {
    return {
      screenVarOpts
    }
  },
  methods: {
    async chooseLedVar(led) {
      let variable = await this.$refs.ledVarDialog.open()
      if (variable != null) {
        this.$set(this.value, 'led' + led.code, variable.value)
        this.$emit('update')
      }
    },

    async editName() {
      let newName = await this.$prompt({
        label: 'Digite o novo nome deste ScreenSet:',
        value: this.value.name
      })

      if (newName != null) {
        this.$set(this.value, 'name', newName)
        this.$emit('update')
      }
    },

    async editComments() {
      let newVal = await this.$prompt({
        label: 'Comentários:',
        value: this.value.comments,
        textarea: true
      })

      if (newVal != null) {
        this.$set(this.value, 'comments', newVal)
        this.$emit('update')
      }
    },

    async editCode() {
      let newVal = await this.$prompt({
        label: 'Digite o código deste ScreenSet:',
        value: parseInt(this.value.code, 16) || null,
        decHex: true
      })

      if (newVal != null) {
        this.$set(this.value, 'code', '0x' + newVal.toString(16))
        this.$emit('update')
      }
    }
  },
  filters: {
    translateVar
  }
}
</script>

<style lang="sass">
.appliesTo-shaped
  background-color: #eee !important
  border-radius: 16px 16px 4px 4px
  border-bottom-width: 1px
  border-bottom-style: solid
  border-bottom-color: #999 !important
  position: relative

  button
    position: absolute
    top: 4px
    right: 4px
</style>
